const useLocalStorage = (key) => {
  let value = localStorage.getItem(key)
  const setValue = (newValue) => localStorage.setItem(key, newValue)

  if (value === 'true') value = true
  else if (value === 'false') value = false

  return [value, setValue]
}

export default useLocalStorage
